<template>
  <div class="dashboard-container">
    <div class="header">
      <h1 class="dashboard-title" style="margin-top: 4rem">
        {{ $t("tools.title") }}
      </h1>
    </div>

    <div class="tools-grid">
      <!-- Card para Simulador de Viabilidade -->
      <router-link to="/simulador" class="tool-card">
        <div class="tool-card-content">
          <div class="tool-icon">
            <i class="fas fa-calculator"></i>
          </div>
          <h3 class="tool-title">{{ $t("tools.viabilitySimulator") }}</h3>
          <p class="tool-description">
            {{ $t("tools.viabilitySimulatorDescription") }}
          </p>
        </div>
      </router-link>

      <!-- Espaço para futuros cards de ferramentas -->
      <!-- Exemplo de card futuro (desativado) -->
      <div class="tool-card" style="opacity: 0.5; cursor: not-allowed;">
        <div class="tool-card-content">
          <div class="tool-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <h3 class="tool-title">{{ $t("tools.equilibriumCalculator") }}</h3>
          <p class="tool-description">
            {{ $t("tools.equilibriumCalculatorDescription") }}
          </p>
        </div>
      </div>

      <!-- Outro exemplo de card futuro (desativado) -->
      <div class="tool-card" style="opacity: 0.5; cursor: not-allowed;">
        <div class="tool-card-content">
          <div class="tool-icon">
            <i class="fas fa-file-invoice-dollar"></i>
          </div>
          <h3 class="tool-title">{{ $t("tools.storeValuation") }}</h3>
          <p class="tool-description">
            {{ $t("tools.storeValuationDescription") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ferramentas"
};
</script>

<style scoped>
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
}

.dashboard-title {
  text-align: center;
  margin-bottom: 40px;
  color: #f0512d;
  font-size: 28px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
}

.tool-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Remover sublinhado e cor padrão de links */
a.tool-card {
  text-decoration: none;
  color: inherit;
}

/* Garantir que títulos dentro dos links mantenham a cor padrão */
a.tool-card .tool-title {
  color: #333;
  transition: color 0.3s ease;
}

/* Efeito hover para o título */
a.tool-card:hover .tool-title {
  color: #f0512d;
}

.tool-card-content {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-grow: 1;
}

.tool-icon {
  font-size: 48px;
  color: #f0512d;
  margin-bottom: 20px;
}

.tool-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.tool-description {
  font-size: 14px;
  color: #888;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  flex-direction: column;
}

.header img {
  max-width: 120px;
  height: auto;
  margin-bottom: 15px;
}
</style>
